// Chess pieces - clean modern style matching reference design
import cleanWhiteKing from "@/assets/pieces/clean-white-king.svg";
import cleanWhiteQueen from "@/assets/pieces/clean-white-queen.svg";
import cleanWhiteRook from "@/assets/pieces/clean-white-rook.svg";
import cleanWhiteBishop from "@/assets/pieces/clean-white-bishop.svg";
import cleanWhiteKnight from "@/assets/pieces/clean-white-knight-modern.svg";
import cleanWhitePawn from "@/assets/pieces/clean-white-pawn.svg";
import cleanBlackKing from "@/assets/pieces/clean-black-king.svg";
import cleanBlackQueen from "@/assets/pieces/clean-black-queen.svg";
import cleanBlackRook from "@/assets/pieces/clean-black-rook.svg";
import cleanBlackBishop from "@/assets/pieces/clean-black-bishop.svg";
import cleanBlackKnight from "@/assets/pieces/clean-black-knight-modern.svg";
import cleanBlackPawn from "@/assets/pieces/clean-black-pawn.svg";

// Classic PNG fallbacks
import classicWhiteKing from "@/assets/pieces/white-king.png";
import classicWhiteQueen from "@/assets/pieces/white-queen.png";
import classicWhiteRook from "@/assets/pieces/white-rook.png";
import classicWhiteBishop from "@/assets/pieces/white-bishop.png";
import classicWhiteKnight from "@/assets/pieces/white-knight.png";
import classicWhitePawn from "@/assets/pieces/white-pawn.png";
import classicBlackKing from "@/assets/pieces/black-king.png";
import classicBlackQueen from "@/assets/pieces/black-queen.png";
import classicBlackRook from "@/assets/pieces/black-rook.png";
import classicBlackBishop from "@/assets/pieces/black-bishop.png";
import classicBlackKnight from "@/assets/pieces/black-knight.png";
import classicBlackPawn from "@/assets/pieces/black-pawn.png";

export const modernPieceImages: { [key: string]: string } = {
  'K': cleanWhiteKing,
  'Q': cleanWhiteQueen,
  'R': cleanWhiteRook,
  'B': cleanWhiteBishop,
  'N': cleanWhiteKnight,
  'P': cleanWhitePawn,
  'k': cleanBlackKing,
  'q': cleanBlackQueen,
  'r': cleanBlackRook,
  'b': cleanBlackBishop,
  'n': cleanBlackKnight,
  'p': cleanBlackPawn
};

export const classicPieceImages: { [key: string]: string } = {
  'K': classicWhiteKing,
  'Q': classicWhiteQueen,
  'R': classicWhiteRook,
  'B': classicWhiteBishop,
  'N': classicWhiteKnight,
  'P': classicWhitePawn,
  'k': classicBlackKing,
  'q': classicBlackQueen,
  'r': classicBlackRook,
  'b': classicBlackBishop,
  'n': classicBlackKnight,
  'p': classicBlackPawn
};